import * as React from "react";

const strokeColor = "#bef264";
const colorFill = "#171717";
const SwipeUpIcon = (props) => (
  <svg
    height={99.176}
    width={99.176}
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M64.581 21.101a4.186 4.186 0 0 0 0 5.908l5.106 5.107c.534.533.539 1.42 0 1.958a1.4 1.4 0 0 1-1.972.015l-9.598-9.599a4.17 4.17 0 0 0-5.908 0 4.173 4.173 0 0 0 .002 5.905l7.623 7.623a1.391 1.391 0 0 1-.004 1.961 1.393 1.393 0 0 1-1.971.014L46.935 29.069a4.174 4.174 0 0 0-5.906.004 4.176 4.176 0 0 0-.002 5.904l10.925 10.924a1.391 1.391 0 0 1-.014 1.97 1.389 1.389 0 0 1-1.959.002L24.834 22.728a4.18 4.18 0 0 0-5.908 0 4.17 4.17 0 0 0 .002 5.908l34.997 34.998-9.462-1.473c-2.998-.635-5.924 1.061-6.566 3.805-.621 2.748 1.296 5.492 4.281 6.145 0 0 16.171 3.303 23.083 4.725 6.917 1.434 14.625.25 22.94-8.064 13.759-13.76 4.367-25.613 1.192-28.789L70.501 21.089c-1.627-1.626-4.285-1.623-5.92.012z"
      fill={colorFill}
      stroke={strokeColor}
      strokeMiterlimit={10}
      strokeWidth={3.483}
    />
    <path
      d="M64.581 21.101a4.186 4.186 0 0 0 0 5.908l5.106 5.107c.534.533.539 1.42 0 1.958a1.4 1.4 0 0 1-1.972.015l-9.598-9.599a4.17 4.17 0 0 0-5.908 0 4.173 4.173 0 0 0 .002 5.905l7.623 7.623a1.391 1.391 0 0 1-.004 1.961 1.393 1.393 0 0 1-1.971.014L46.935 29.069a4.174 4.174 0 0 0-5.906.004 4.176 4.176 0 0 0-.002 5.904l10.925 10.924a1.391 1.391 0 0 1-.014 1.97 1.389 1.389 0 0 1-1.959.002L24.834 22.728a4.18 4.18 0 0 0-5.908 0 4.17 4.17 0 0 0 .002 5.908l34.997 34.998-9.462-1.473c-2.998-.635-5.924 1.061-6.566 3.805-.621 2.748 1.296 5.492 4.281 6.145 0 0 16.171 3.303 23.083 4.725 6.917 1.434 14.625.25 22.94-8.064 13.759-13.76 4.367-25.613 1.192-28.789L70.501 21.089c-1.627-1.626-4.285-1.623-5.92.012z"
      fill={colorFill}
      stroke={strokeColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
    />
    <path
      clipRule="evenodd"
      d="M11.342 44.398c2.236-1.666 5.732-6.215 8.091-2.482 2.639 4.179 2.592 8.847 4.227 12.857-.621 1.164-1.985 1.76-2.821 1.039-.608-.309-.169-.881-.23-1.326-1.029-3.283-1.366-6.742-3.14-9.835-4.698 5.691-8.413 13.736-7.566 20.427.422 3.355 2.066 7.943 4.489 10.133 1.14 1.031 2.615.855 3.36 2.336.387.787-1.186 1.508-1.894 1.758-3.853-1.838-6.049-5.002-7.183-8.17-2.73-7.652-.904-16.476 4.825-24.945-2.666 1.227-5.036 3.611-7.529 5.531-.764-.09-1.387.395-2.274-.168 1.26-3.357 4.651-4.923 7.645-7.155z"
      fill={strokeColor}
      fillRule="evenodd"
    />
  </svg>
);

export default SwipeUpIcon;
